import { ApiProperty } from "@nestjs/swagger";

export class JobWorkApproverDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    name: string;

    @ApiProperty()
    unitName: string;

    @ApiProperty()
    approver: string;

    @ApiProperty()
    orderNo: string;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;
}